module.exports = __webpack_public_path__ + "img/banner_tc.a36352a8.png";